import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';
import type { UserSearch } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/usersearch`,
    query: {} as {
      username?: string;
      first?: string;
      last?: string;
      mobile?: string;
      limit?: number;
      offset?: number;
      search?: string;
    },
    response: [] as UserSearch.Get.User[],
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
